import { Box, Button, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";

import {
  filterFunc,
  setSearchedTerm,
} from "../../../redux/actions/actions";
import { useTranslation } from "react-i18next";

export default function Search() {
  const { t } = useTranslation();

  const mobileDevice = useSelector((state) => state.windowWidth.width); // Filtrelenmiş ürünleri al
  const [searchTerm, setSearchTerm] = useState("");
  const selectedFilters = useSelector((state) => state.filters.selectedFilters); // Arama terimini al
  const pageType = useSelector((state) => state.filters.pageType);
  const searchedTerm = useSelector((state) => state.searchTerm.searchTerm); // Arama terimini al
  // const [searchType, setSearchType] = useState({});
  const [clearSearch, setClearSearch] = useState(false);

  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );
  const searchTermTypeRef = useRef();
  const dispatch = useDispatch();

  const handleClearSearh = () => {
    setSearchTerm("");

    dispatch(setSearchedTerm({}));

    setClearSearch(false);
  };

  /*   useEffect(() => {
      if (pageType) {
        if (pageType === "commissions") {
          setSearchType({
            name: t("invoiceId"),
            id: "invoice_id",
          });
        }
        if (pageType == "bookings") {
          setSearchType({
            name: t("studentName"),
            id: "student_name",
          });
        }
        if (pageType == "partner_requests") {
          setSearchType({
            name: t("studentName"),
            id: "student_name",
          });
        }
        if (pageType == "invoices") {
          setSearchType({
            name: t("invoiceId"),
            id: "invoice_id",
          });
        }
        if (pageType == "quotes") {
          setSearchType({
            name: t("quoteId"),
            id: "quote_id",
          });
        }
        if (pageType == "discount_request") {
          setSearchType({
            name: t("quoteId"),
            id: "quote_id",
          });
        }
      }
    }, [pageType]); */


  const searchTypeMap = {
    commissions: { name: t("invoiceId"), id: "invoice_id" },
    bookings: { name: t("studentName"), id: "student_name" },
    partner_requests: { name: t("studentName"), id: "student_name" },
    invoices: { name: t("invoiceId"), id: "invoice_id" },
    quotes: { name: t("quoteId"), id: "quote_id" },
    discount_request: { name: t("quoteId"), id: "quote_id" },
  };

  const searchType = searchTypeMap[pageType] || {};


  const handleSubmit = (e) => {
    e.preventDefault();

    let searchTermType = searchTermTypeRef.current.lastChild.firstChild.id;

    dispatch(setSearchedTerm({ searchTerm, searchTermType }));
    setClearSearch(true);
  };

  useEffect(() => {
    if (
      Object.keys(searchedTerm).length &&
      !Object.keys(selectedFilters).length
    ) {
      dispatch(
        filterFunc(
          selectedFilters,
          pageType,
          searchedTerm,
          selectedBranchesString
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchedTerm, selectedBranchesString]);
  return (
    <>
      {/* <form onSubmit={handleSubmit}>
        <TextField
          ref={searchTermTypeRef}
          id={searchType?.id}
          label={searchType?.name}
          variant="outlined"
          onChange={(e) => handleSearchTerm(e)}
        />
      </form> */}

      <Box
        sx={{
          display: "flex",
          flexDirection: mobileDevice < 768 ? "column" : "row",
          alignItems: "stretch",
          justifyContent: "center",
          marginRight: mobileDevice < 768 ? "0" : "auto",
          order: mobileDevice < 768 ? "2" : "1",
        }}
      >
        <Box
          sx={{
            position: "relative",
            marginRight: mobileDevice < 768 ? "0" : "1rem",
          }}
        >
          <TextField
            ref={searchTermTypeRef}
            id={searchType?.id}
            label={searchType?.name}
            variant="outlined"
            onChange={(e) => {
              const value = e.target.value;
              // Sadece harfler ve boşluk karakterine izin ver
              if (searchType?.id === "student_name") {
                // if (/^[a-zA-Z\s]*$/.test(value)) {
                if (/^[a-zA-ZçÇğĞıİöÖşŞüÜ\s]*$/.test(value)) {
                  setSearchTerm(value);
                }
              } else {
                setSearchTerm(value);
              }
            }}
            // onChange={(e) => handleSearchTerm(e)}
            value={searchTerm}
            sx={{
              width: "100%",
              ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
                paddingRight: "2rem",
              },
            }}
            type={
              searchType?.id === "invoice_id" || searchType?.id === "quote_id"
                ? "number"
                : "text"
            }
          />
          {clearSearch ? (
            <CloseIcon
              sx={{
                position: "absolute",
                right: ".5rem",
                top: "calc(50% - 12px)",
                cursor: "pointer",
              }}
              onClick={handleClearSearh}
            />
          ) : null}
        </Box>

        <Button
          sx={{ marginTop: mobileDevice < 768 ? "1rem" : "0" }}
          onClick={(e) => Object.keys(searchTerm).length && handleSubmit(e)}
          variant="contained"
          color="primary"
          disabled={!Object.keys(searchTerm).length}
        >
          {t("search")}
        </Button>
      </Box>
    </>
  );
}
